export const PEOPLE_FILTERS = {
  NAME: 'name',
  TEAM: 'team',
};
